import {
  GET_OPPORTUNITY,
  CREATE_OPPORTUNITY,
  UPDATE_OPPORTUNITY,
  DELETE_OPPORTUNITY,
  CREATE_iNFORMATION,
  UPDATE_INFORMATION,
} from "../actions/types";

const initialState = {
  opportunities: [],
  opportunity: null,
  information: null,
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  switch (action.type) {
    case GET_OPPORTUNITY:
      return {
        ...state,
        opportunities: action.payload,
      };
    case CREATE_OPPORTUNITY:
      return {
        ...state,
        opportunities: [...state.opportunities, action.payload],
        opportunity: action.payload,
      };
    case UPDATE_OPPORTUNITY:
      return {
        ...state,
        opportunities: state.opportunities.map(opp => 
          (opp.id === action.payload.id || opp._id === action.payload._id) ? action.payload : opp
        ),
        opportunity: action.payload,
      };
    case CREATE_iNFORMATION:
      return {
        ...state,
        information: action.payload,
      };
    case UPDATE_INFORMATION:
      return {
        ...state,
        information: action.payload,
      };
    case DELETE_OPPORTUNITY:
      return {
        ...state,
        opportunities: state.opportunities.filter(opp => 
          opp.id !== action.payload.id && opp._id !== action.payload.id
        ),
      };
    default:
      return state;
  }
}

